// ce fichier ets la pour forcer le chargement de la traduction en français
export const messages = {
    "Use system language": "Langue du système"
}